"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListFilterable = void 0;
const Utilities_1 = require("../../javascript/Utilities");
class ListFilterable {
    static getGridColumnFilterable(options, col) {
        if (options.filterableCols) {
            if (col.isFtField)
                return ListFilterable.getFtGridColumnFilterable(col);
            else if (col.dbColType === "string")
                return ListFilterable.getStringGridColumnFilterable(col);
            else if (col.dbColType === "float" || col.dbColType === "digit" || col.dbColType === "bigdigit")
                return ListFilterable.getNumberGridColumnFilterable(col);
            else if (col.dbColType === "date")
                return ListFilterable.getDateGridColumnFilterable(col);
            else if (col.dbColType === "datetime")
                return ListFilterable.getDateTimeGridColumnFilterable(col);
            else if (col.dbColType === "time")
                return ListFilterable.getTimeGridColumnFilterable(col);
        }
        return false;
    }
    static getFtGridColumnFilterable(col) {
        return {
            multi: true,
            search: true,
            checkAll: true,
            filter: {
                type: col.dbColType,
                itemDefaults: {
                    enableKeyEvents: false,
                    listeners: {
                        specialkey(field, e) {
                            if (e.getKey() === e.ENTER) {
                                let f = this.up("gridcolumn").filter;
                                f.task.delay(500, undefined, undefined, [f.getValue(field)]);
                            }
                        }
                    }
                }
            }
        };
    }
    static getStringGridColumnFilterable(col) {
        return {
            extra: false,
            operators: {
                string: {
                    contains: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgcontains"),
                }
            },
            cell: {
                showOperators: false,
                operator: "contains",
                suggestionOperator: "contains",
                inputWidth: 250,
            },
            filter: {
                type: "string",
                itemDefaults: {
                    enableKeyEvents: false,
                    listeners: {
                        specialkey(field, e) {
                            if (e.getKey() === e.ENTER) {
                                let f = this.up("gridcolumn").filter;
                                f.task.delay(500, undefined, undefined, [f.getValue(field)]);
                            }
                        }
                    }
                }
            }
        };
    }
    static getNumberGridColumnFilterable(col) {
        return {
            multi: col.multiValue,
            extra: false,
            operators: {
                number: ListFilterable.getFilterOperators()
            },
            filter: {
                type: col.dbColType,
                itemDefaults: {
                    enableKeyEvents: false,
                    listeners: {
                        specialkey(field, e) {
                            if (e.getKey() === e.ENTER) {
                                let f = this.up("gridcolumn").filter;
                                f.task.delay(500, undefined, undefined, [f.getValue(field)]);
                            }
                        }
                    }
                }
            }
        };
    }
    static getDateGridColumnFilterable(col) {
        return {
            multi: col.multiValue,
            ui($elem) {
                $elem.kendoDatePicker({
                    format: kendo.culture().calendar.patterns.d
                });
            },
            operators: {
                date: ListFilterable.getFilterOperators()
            }
        };
    }
    static getDateTimeGridColumnFilterable(col) {
        return {
            multi: col.multiValue,
            ui($elem) {
                $elem.kendoDateTimePicker({
                    format: kendo.culture().calendar.patterns.G
                });
            },
            operators: {
                date: ListFilterable.getFilterOperators()
            }
        };
    }
    static getTimeGridColumnFilterable(col) {
        return {
            multi: col.multiValue,
            ui($elem) {
                $elem.kendoTimePicker({
                    format: kendo.culture().calendar.patterns.T,
                    min: Utilities_1.synUtil.jsonToTime("00:00:00"),
                    max: Utilities_1.synUtil.jsonToTime("23:59:59")
                });
            },
            operators: {
                date: ListFilterable.getFilterOperators()
            }
        };
    }
    static prepareListFilterMenu($filterMenu, targetCol) {
        if ($filterMenu) {
            $filterMenu.addClass("synListFilterMenu");
            $filterMenu.find(".k-dropdown").each((_idx, elem) => {
                const ddl = $(elem).find("select").data("kendoDropDownList");
                ddl.ul.closest(".k-list-container").addClass("synListFilterOperatorContainer");
            });
            const colType = targetCol.dbColType;
            if (!targetCol.multiValue && (colType === "float" || colType === "digit" || colType === "bigdigit" || colType === "string")) {
                $filterMenu.find(".k-filter-help-text").hide();
                $filterMenu.find(".k-dropdown").hide();
            }
            if (targetCol.multiValue || targetCol.isFtField)
                $filterMenu.addClass("synListMultiFilterMenu");
        }
    }
}
exports.ListFilterable = ListFilterable;
ListFilterable.getFilterOperators = () => {
    return {
        gt: Utilities_1.synUtil.Strings.getValue("dynpsearchdlggreater"),
        gte: Utilities_1.synUtil.Strings.getValue("dynpsearchdlggreaterequal"),
        eq: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgequal"),
        lte: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgsmallerequal"),
        lt: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgsmaller"),
        neq: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgnotequal"),
        isnull: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgisnull"),
        isnotnull: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgisnotnull")
    };
};
